module.exports = __webpack_public_path__ + "img/person-icon-orange.904850ec.svg";